<div class="content-wrapper">
    <div class="content-body">
        <section id="university-popular-courses">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <h2 class="mt-5px">Linked Popular Courses</h2>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <button class="btn btn-primary pull-right color-white users-btn cursor-pointer"
                            (click)="toggleLinkPanel()">
                        <i aria-hidden="true" class="fa fa-plus-circle mr-8px"></i>&nbsp;Link Courses
                    </button>
                </div>
            </div>

            <div class="row search-card mt-3" *ngIf="showLinkPanel">
                <div class="col-12">
                    <div class="card p-2">
                        <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                            <div class="row">
                                <div class="col-md-8 col-lg-8 col-sm-8 col-xs-12">
                                    <fieldset class="form-group">
                                        <input class="form-control" type="text" formControlName="course"
                                               placeholder="Search popular course by name">
                                    </fieldset>
                                </div>
                                <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="searching"></i>
                                </div>
                            </div>
                        </form>
                        <div class="row" *ngIf="catalogCourses && catalogCourses.length > 0">
                            <div class="col-12">
                                <div class="d-flex justify-content-between align-items-center py-1"
                                     style="border-bottom: 1px solid #eee"
                                     *ngFor="let course of catalogCourses">
                                    <label class="d-flex align-items-center mb-0">
                                        <input type="checkbox" class="mr-2"
                                               [checked]="isSelected(course)"
                                               (change)="toggleSelected(course)">
                                        <span>{{course?.course}} <small class="text-muted">({{course?.short_name}})</small></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-1" *ngIf="catalogCourses.length === 0 && !searching">
                            <div class="col-12">
                                <small class="text-muted">No matching courses found.</small>
                            </div>
                        </div>
                        <div class="row mt-2" *ngIf="catalogCourses && catalogCourses.length > 0">
                            <div class="col-12">
                                <button class="btn btn-sm btn-primary color-white"
                                        [disabled]="submitting || selectedIds.size === 0"
                                        (click)="linkSelected()">
                                    Link Selected ({{selectedIds.size}})
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row d-none d-md-block mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="container-fluid">
                            <div class="row d-none d-md-block overflow-x-scroll overflow-table">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <table class="table table-list">
                                        <thead>
                                        <tr>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">S.No</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Course</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Short
                                                Name</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Action</h6>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody *ngIf="linkedCourses && linkedCourses.length > 0; else noDataToShowWeb">
                                        <tr *ngFor="let course of linkedCourses; let i = index">
                                            <td class="text-center">
                                                <h6 class="mt-1">{{i + 1}}.</h6>
                                            </td>
                                            <td class="text-center"><h6 class="mt-1">{{course?.course}}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{course?.short_name}}</h6>
                                            </td>
                                            <td class="text-center">
                                                <button class="btn btn-sm btn-danger" [disabled]="submitting"
                                                        (click)="unlink(course)">Unlink
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <ng-template #noDataToShowWeb>
                                            <tbody>
                                            <tr>
                                                <td colspan="4" class="text-center"><h6>No popular courses linked to
                                                    this university yet</h6></td>
                                            </tr>
                                            </tbody>
                                        </ng-template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
